export default "__VITE_ASSET__a6c8d7f7__"